var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyArrowSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#03A66D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7558 10.2444C19.43 9.91854 18.9033 9.91854 18.5775 10.2444L11.6667 17.1552V12.5002C11.6667 12.0402 11.2942 11.6669 10.8333 11.6669C10.3725 11.6669 10 12.0402 10 12.5002V19.1669C10 19.6269 10.3725 20.0002 10.8333 20.0002H17.5C17.9608 20.0002 18.3333 19.6269 18.3333 19.1669C18.3333 18.7069 17.9608 18.3335 17.5 18.3335H12.845L19.7558 11.4227C20.0817 11.0969 20.0817 10.5702 19.7558 10.2444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyArrowSquare);
export default __webpack_public_path__ + "static/media/buy-arrow-square.6f8cc94d5ee89a242eea4f36089034f4.svg";
export { ForwardRef as ReactComponent };